import React, { useState } from "react";
import FolderIcon from "../../Assets/Images/Common/folder.svg";
import FileIcon from "../../Assets/Images/Common/file.svg";
import cssClasses from "./FileManager.module.css";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import SelectManagerModal from "./SelectManagerModal";
import ImgIcon from "../../Assets/Images/Common/ImgIcon.svg";
import PreviewFolderIcon from "../../Assets/Images/Common/PreviewFolderIcon.svg";
import PreviewFileIcon from "../../Assets/Images/Common/PreviewFileIcon.svg";
import { useEffect } from "react";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import NewFolderModal from "../Project/NewFolderModal/NewFolderModel";
import { errorTost, successTost } from "../../Services/Toast";
import PreviewModal from "./PreviewModal";
import MsExcelIcon from "../../Assets/Images/Common/MsExcel.svg";
import PreviewExcelIcon from "../../Assets/Images/Common/PreviewSheetsIcon.svg";
import MsWordIcon from "../../Assets/Images/Common/MsWord.svg";
import PreviewWordIcon from "../../Assets/Images/Common/PreviewWordIcon.svg";
import PowerPointIcon from "../../Assets/Images/Common/MsPowerPoint.svg";
import PreviewPowerPointIcon from "../../Assets/Images/Common/PreviewSlidesIcon.svg";
import PdfIcon from "../../Assets/Images/Common/Pdf.svg";
import PreviewPdfIcon from "../../Assets/Images/Common/PreviewPdfIcon.svg";
import VideoIcon from "../../Assets/Images/Common/Video.svg";
import {
  AddProjectCollateralWithCp,
  AddProjectCollateralWithSales,
} from "../../Services/Project";
import { dismissLoader, presentLoader } from "../../Services/loader";
import axios from "axios";

const FileManager = ({
  value,
  handleSetToggle,
  handleDeleteFile,
  handleDownloadFile,
}) => {
  const [data, setData] = useState([]);
  const [selectedFile, setSelectedFile] = useState();
  const [selectManagerModalOpen, setSelectManagerModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteFile, setSelectedDeleteFile] = useState("");
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [fileOptions, setFileOptions] = useState([
    { id: 0, value: "Share", label: "Share" },
    { id: 1, value: "Copy Link", label: "Copy Link" },
    { id: 2, value: "Preview", label: "Preview" },
    { id: 3, value: "Download", label: "Download" },
    { id: 4, value: "Delete", label: "Delete" },
  ]);
  const [folderOptions, setFolderOptions] = useState([
    { id: 0, value: "Share", label: "Share" },
    // { id: 1, value: "Download", label: "Download" },
    { id: 2, value: "Delete", label: "Delete" },
  ]);

  useEffect(() => {
    if (value?.length > 0) {
      setData(value);
    }
  }, [value]);

  const handleOpenPreviewModal = (value) => {
    setShowPreviewModal(true);
    setSelectedFile(value);
  };

  const handleShareCollateral = (
    cpNames,
    salesName,
    selectedFile,
    selectDates
  ) => {
    setSelectManagerModalOpen(false);
    presentLoader();
    const obj = {
      cpidarr: cpNames?.length > 0 ? [...cpNames] : [],
      salesidarr: salesName?.length > 0 ? [...salesName] : [],
      projectCollateralId: selectedFile?.projectCollateralId,
      startDateTime: Date.parse(new Date(selectDates[0]?.value)),
      endDateTime: Date.parse(new Date(selectDates[1]?.value)),
    };
    axios
      .post(process.env.REACT_APP_PAYMENT_LINK_URL + "scheduler/ShareFolder", {
        ...obj,
      })
      .then(() => {
        successTost("Collateral shared sucessfully.");
        dismissLoader();
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  return (
    <div className={cssClasses.mainWrapper}>
      <div className={cssClasses.fileManagerContainer}>
        {data.map((val) => {
          return (
            <div
              className={cssClasses.folderWrapper}
              onDoubleClick={() => {
                val?.fileType === "folder" && handleSetToggle(val);
              }}
            >
              <div>
                {val?.fileType !== "video" ? (
                  <img
                    src={
                      val.fileType === "folder"
                        ? PreviewFolderIcon
                        : val?.fileType === "image"
                        ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                          val?.fileUrl
                        : val?.fileType === "SpreadSheet"
                        ? PreviewExcelIcon
                        : val?.fileType === "Word File"
                        ? PreviewWordIcon
                        : val?.fileType === "Presentation"
                        ? PreviewPowerPointIcon
                        : val?.fileUrl.includes(".pdf")
                        ? PreviewPdfIcon
                        : PreviewFileIcon
                    }
                    className={`${
                      val.fileType === "image" ? cssClasses.imgContainer : ""
                    }`}
                    alt="icon"
                    onClick={() => {
                      (val?.fileType === "image" ||
                        val?.fileType === "SpreadSheet" ||
                        val?.fileType === "Word File" ||
                        val?.fileType === "Presentation" ||
                        val?.fileUrl.includes(".pdf")) &&
                        handleOpenPreviewModal(val);
                    }}
                  />
                ) : (
                  <video
                    src={
                      process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                      val?.fileUrl
                    }
                    alt="video"
                    className={cssClasses.imgContainer}
                    onClick={() => handleOpenPreviewModal(val)}
                  />
                )}
              </div>
              <div className={cssClasses.iconWrapper}>
                <img
                  src={
                    val?.fileType === "folder"
                      ? FolderIcon
                      : val?.fileType === "image"
                      ? ImgIcon
                      : val?.fileType === "SpreadSheet"
                      ? MsExcelIcon
                      : val?.fileType === "Word File"
                      ? MsWordIcon
                      : val?.fileType === "Presentation"
                      ? PowerPointIcon
                      : val?.fileUrl.includes(".pdf")
                      ? PdfIcon
                      : val?.fileType === "video"
                      ? VideoIcon
                      : FileIcon
                  }
                  alt="icon"
                />
                <span className={cssClasses.label}>{val.name}</span>{" "}
                <ThreeDotsMenu
                  list={val.fileType === "folder" ? folderOptions : fileOptions}
                  selectedValue={(e) => {
                    if (e.label === "Share") {
                      setSelectManagerModalOpen(true);
                      setSelectedFile(val);
                    } else if (e.label === "Delete") {
                      setShowDeleteModal(true);
                      setSelectedDeleteFile(val?.name);
                    } else if (e.label === "Rename") {
                      setShowRenameModal(true);
                      setSelectedFileName(val?.name);
                    } else if (e.label === "Copy Link") {
                      navigator.clipboard.writeText(
                        process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                          val?.fileUrl
                      );
                      successTost("Link Copied.");
                    } else if (e.label === "Preview") {
                      setShowPreviewModal(true);
                      setSelectedFile(val);
                    } else if (e.label === "Download") {
                      handleDownloadFile(val);
                    }
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {showPreviewModal && (
        <PreviewModal
          open={showPreviewModal}
          handleClose={() => {
            setShowPreviewModal(false);
          }}
          value={selectedFile}
          fileOptions={fileOptions}
          setSelectManagerModalOpen={setSelectManagerModalOpen}
          setSelectedFile={setSelectedFile}
          setSelectedDeleteFile={setSelectedDeleteFile}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
      {selectManagerModalOpen && (
        <SelectManagerModal
          open={selectManagerModalOpen}
          handleClose={() => {
            setSelectManagerModalOpen(false);
          }}
          selectedFile={selectedFile}
          submitHandler={(cp, sm, selectedFile, selectDates) => {
            handleShareCollateral(cp, sm, selectedFile, selectDates);
          }}
        />
      )}
      {showRenameModal && (
        <NewFolderModal
          open={showRenameModal}
          handleClose={() => {
            setShowRenameModal(false);
          }}
          label={"Rename"}
          submitHandler={(e) => {
            setShowRenameModal(false);
          }}
          nameValue={selectedFileName}
        />
      )}
      {showDeleteModal && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              setShowDeleteModal(false);
              handleDeleteFile(selectedDeleteFile);
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Delete"}
          close={() => {
            setShowDeleteModal(false);
          }}
          title={"Delete ?"}
          subTitle={`${selectedDeleteFile} will be deleted forever`}
          open={showDeleteModal}
        />
      )}
    </div>
  );
};

export default FileManager;
